import _ from 'lodash'
import { MutationTree } from 'vuex'
import { ClassRecordsState } from '@/store/lessons/classRecord/types'

const mutations: MutationTree<ClassRecordsState> = {
  godClassRecord: (state, classRecord) => {
    state.classRecords = _.uniqBy([
      classRecord,
      ...state.classRecords,
    ], 'lessonId')
  },
}

export default mutations
